export default {
    SET_BLOCKED_ROUTES(state, routes) {
        state.blocked_routes = Array.isArray(routes) ? routes : []
    },
    SET_LOADING(state, loading) {
        state.loading = Boolean(loading)
    },
    SET_POLL_HANDLE(state, handle) {
        state.poll_handle = handle
    },
}
